import React from 'react';

/**
 * MyProposalsHeader — extracted from MyProposals.jsx (Phase 7 refactor).
 * Renders the page title, subtitle, and bulk action buttons.
 * Zero logic changes. All state/handlers passed as props from parent.
 */
const MyProposalsHeader = ({
    isManager,
    selectedIds,
    isBulkDownloading,
    handleBulkDownload,
    onBulkDelete
}) => (
    <header className="proposals-header">
        <div className="header-left">
            <h1>{isManager ? 'Proposals Workspace' : 'My Workspace'}</h1>
            <p className="subtitle">
                {isManager
                    ? 'Manage proposal workflows, deadlines, and team progress efficiently.'
                    : 'Manage your assigned tasks, proposals, and deadlines efficiently'}
            </p>
        </div>
        <div className="header-actions">
        </div>
    </header>
);

export default MyProposalsHeader;
